/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Selectors for the location module
 */

import { createSelector } from '@zcode/memoizers'
import type { State } from '@zcode/state-type'
import { isNumber } from '@zcode/utils'
import { compose } from 'redux'

// TODO: move this to the currentSeach module when it's created
export const selectCurrentSearch = (state: State) => state.currentSearch

export const selectLocation = compose((state) => state?.location, selectCurrentSearch)

export const selectBox = compose((state) => state?.box, selectLocation)

export const selectLat = compose((state) => state?.lat, selectLocation)

export const selectLng = compose((state) => state?.lng, selectLocation)

export const selectCenter = createSelector(selectLat, selectLng, (lat, lng) => ({ lat, lng }))

export const selectCityName = compose((state) => state?.cityName, selectLocation)

export const selectHoodName = compose((state) => state?.hoodName, selectLocation)

export const selectStateName = compose((state) => state?.stateName, selectLocation)

export const selectCountry = compose((state) => state?.country, selectLocation)

export const selectUrl = compose((state) => state?.url, selectLocation)

export const selectZoom = compose((state) => state?.zoom, selectLocation)

export const selectReady = createSelector(
  selectLat,
  selectLng,
  selectZoom,
  (lat, lng, zoom) => !!(isNumber(lat) && isNumber(lng) && isNumber(zoom))
)
